<template>
  <div
    class="mobile act-lang"
    :class="{ open: showLangList }"
    @mouseenter="onPcHover"
    @mouseleave="onPcLeave"
  >
    <div class="lang-btn" @click="toggleMobileLangList">
      {{ langMap[locale] }}
    </div>
    <div class="lang-list" @click.stop v-show="showLangList">
      <div class="lang-item" v-for="item in langList" :key="item.value"
      @click="changeLang(item.value); $event.stopPropagation();">
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed, ref, onMounted, onUnmounted, defineProps } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { langMap, supportedLangs } from '@/config/lang'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
const store = useStore()
const router = useRouter()
const route = useRoute()
const AccumRechargeDisableLang = ['in']
const { locale } = useI18n()
const showLangList = ref(false)
const isLangSelected = ref(false)

const langList = computed(() => {
  const langs = supportedLangs.map(lang => ({
    label: langMap[lang],
    value: lang
  }))
  if (route.name === 'AccumRecharge') {
    return langs.filter(lang => !AccumRechargeDisableLang.includes(lang.value))
  }
  return langs
})

// 切换语言列表显示/隐藏
const toggleMobileLangList = () => {
  if (isMobile) {
    showLangList.value = !showLangList.value
  }
}

// 切换语言
const changeLang = (lang) => {
  showLangList.value = false
  isLangSelected.value = true
  
  // 延迟重置状态，给用户足够时间移开鼠标
  setTimeout(() => {
    isLangSelected.value = false
  }, 500)
  
  // 使用 window.location.href 强制刷新页面，解决切换语言后页面变白的问题
  const currentRoute = router.currentRoute.value
  const resolved = router.resolve({ 
    name: currentRoute.name, 
    params: { ...currentRoute.params, locale: lang },
    query: currentRoute.query,
    hash: currentRoute.hash
  })
  
  if (resolved.href) {
    window.location.href = resolved.href
  }
}

// 点击外部关闭下拉框
const closeDropdown = (e) => {
  if (!e.target.closest('.act-lang')) {
    showLangList.value = false
  }
}

// 在PC端鼠标悬停时显示语言列表
const onPcHover = () => {
  if (!isMobile) {
    showLangList.value = true
  }
}

const onPcLeave = () => {
  if (!isMobile) {
    showLangList.value = false
  }
}

// 添加点击事件监听
onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

// 组件卸载时移除监听
onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<style lang="less" scoped>
.act-lang {
  position: absolute;
  top: 12.3px;
  left: 594px;
  width: 158px;
  height: 45.7px;
  z-index: 102;
  overflow: hidden;
  font-size: 22px;

  &.open {
    height: auto;
    background: #5041ac;
    border-radius: 0 0 4px 4px;
  }

  .lang-btn {
    position: relative;
    width: 158px;
    height: 45.7px;
    padding: 0 34px 0 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('~@/assets/imgs/act/ann2026/hero/language-trigger-bg.png') no-repeat;
    background-size: 158px 45.7px;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
    user-select: none;

    &::after {
      content: '';
      position: absolute;
      top: 17.4px;
      right: 13px;
      width: 19px;
      height: 11px;
      background: url('~@/assets/imgs/act/ann2026/hero/language-arrow.png') no-repeat;
      background-size: 19px 11px;
    }
  }

  .lang-list {
    position: relative;
    width: 158px;
    height: auto;
    overflow: visible;
  }

  .lang-item {
    width: 158px;
    height: 45.35px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: url('~@/assets/imgs/act/ann2026/hero/language-option-bg.png') no-repeat;
    background-size: 158px 45.7px;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
  }
}
</style>
